import { Game } from "./Game";
import { PromoItem } from "../molecules/PromoCarousel/PromoCarousel";
import { checkFullPath } from "../../utils";

export class PromoTile {
  public static fromData(item: PromoItem): PromoTile {
    const promoTile = new PromoTile();

    promoTile.key = item.key;
    promoTile.title = item.title;
    promoTile.description = item.description;
    promoTile.buttonTitle = item.buttonTitle;
    promoTile.link = item.link;
    promoTile.imageSrc = item.imageSrc;
    promoTile.target = item.isTargetBlank ? "_blank" : "_self";
    promoTile.game = null;
    promoTile.alt = item.title;

    return promoTile;
  }

  public static fromGame(game: Game): PromoTile {
    const promoTile = new PromoTile();
    const buildImageUrl = checkFullPath(game.assetOriginUrl, game.promoThumbPath);

    promoTile.key = game.slug;
    promoTile.title = Game.getOnPageTitle(game);
    promoTile.description = game.seo_PromoDescription || game.description;
    promoTile.buttonTitle = "Play Now";
    promoTile.link = game.seo_IsFakeGame
      ? game.seo_FinalURL
      : Game.getURLAlias(game);

    promoTile.imageSrc = buildImageUrl.toString();
    promoTile.target = "_self";
    promoTile.game = game;
    promoTile.alt = Game.getOnPageTitle(game);

    return promoTile;
  }

  public key: string;
  public title: string;
  public description: string;
  public buttonTitle: string;
  public link: string;
  public imageSrc: string;
  public target: string;
  public game: Game;
  public alt?: string;
}
